import overArg from './_overArg.js';

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

export default getPrototype;



//////////////////
// WEBPACK FOOTER
// ../node_modules/lodash-es/_getPrototype.js
// module id = 95
// module chunks = 0


// WEBPACK FOOTER //
// node_modules/lodash-es/_getPrototype.js